import Axios from '@/common/require'
export default {
  LOGIN(store,data) {
    return new Promise((resolve, reject) => {
      Axios({
        url: '/api.php/console/login/login',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        localStorage.setItem('token',dt.token)
        localStorage.setItem('refresh_token',dt.refresh_token)
        localStorage.setItem('access_token',dt.access_token)
        store.commit('SET_TOKEN',dt.token);
        store.commit('SET_REFRESH_TOKEN',dt.refresh_token);
        store.commit('SET_ACCESS_TOKEN',dt.access_token);
        store.commit('SET_USER_INFO',dt.info);
        resolve(dt);
      })
    })
    
  },
  // 重置当前的管理员信息
  UPDATA_USER_INFO(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/console/login/myinfo',
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 获取当前登录信息
  GET_USER_INFO(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/api.php/console/login/info',
        data,
        options:{
          method:'post',
          load:0,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/user/actions.js